import React from 'react';
import cn from 'classnames';

import Field from 'brandComponents/Form/Subcomponents/Field';
import Icon from 'brandComponents/Icon';

import {ICheckboxFieldProps} from './ICheckboxField';

import styles from './CheckboxField.module.scss';

const CheckboxField = ({classNamesCntr, ref, ...config}: ICheckboxFieldProps) => {

	return (
		<Field
			{...config}
			classNamesCntr={cn(classNamesCntr, styles['checkbox-field'])}
			id={undefined}
			type="checkbox"
			ref={ref}
			customIcon={
				<span className={styles['checkbox-field__checkmark']}>
					<Icon name="checkmark-x" />
				</span>
			}
		/>
	);
};

export default CheckboxField;
